import cookies from '@/utils/cookie'

async function submitScore(self, query, scoreList, basicInfo, imgAddrList, duration, type, isFastScore = false, isHorizontalImage, puzzleContent = null) {
	let pkIds = [],
		score = [],
		textTopic = [],
		isScoreLegal = true,
		isMinStep = true,
		currentStep = null
	for (let i = 0; i < scoreList.length; i++) {
		let res = scoreList[i]
		if (res.getScore % 0.5 !== 0) {
			isMinStep = false
			break
		}
		if (res.stepScore > 0 && res.getScore !== res.score && res.getScore % res.stepScore !== 0) {
			currentStep = res.stepScore
			isScoreLegal = false
			break
		}
		pkIds.push(res.pkId + '')
		textTopic.push(`${res.bigTopic}${res.smallTopic}`)
		if (query.type === 2) {
			score.push(0)
		} else {
			let curScore = res.getScore ? res.getScore.toString() : '0'
			score.push(curScore)
		}
	}
	if (!isMinStep) {
		self.$message.error(`打分不合法，最小步长为：0.5`)
		return false
	}
	if (!isScoreLegal) {
		self.$message.error(`打分不合法，固定步长为：${currentStep}`)
		return false
	}
	const imgAddr = {
		imgAddr: imgAddrList,
		isFastScore: isFastScore,
		isHorizontalImage: isHorizontalImage,
		deviceName: 'pc'
	}
	let remark = ''
	if (type === -2 || type === 1) remark = puzzleContent
	let arbitramentScore = cookies.get('arbitramentScore')
	const params = {
		examId: query.examId,
		examSubjectId: query.examSubjectId,
		paperTextTaskId: query.paperTextTaskId,
		type: type,
		pkIds: JSON.stringify(pkIds),
		score: JSON.stringify(score),
		textTopic: JSON.stringify(textTopic),
		studentId: basicInfo.studentId,
		markingImageId: basicInfo.markingImageId,
		markingTaskId: query.markingTaskId,
		examAnswerMarkingId: basicInfo.examAnswerMarkingId,
		arbitramentScore,
		duration: duration,
		remark: remark,
		imgAddr: JSON.stringify(imgAddr)
	}
	let finalCanNotExam = localStorage.getItem('finalCanNotExam')
	if (finalCanNotExam === '1' && type === '0') {
		self.$message({ type: 'error', message: '当前试卷，已终评，不能再修改分数！', duration: 3000 })
		return false
	}
	self.eventBus.$emit('emitScoreCurrentIndex', 0)
	self.eventBus.$emit('historyBoardState', false)
	return self.$post('examAnswerScore/phoneBatchMakingScore', params).then(resp => {
		if (resp.code === '200') {
			self.eventBus.$emit('isTypical', { state: false })
			return resp
		}
	})
}

// 判断是否全部搜打完分
async function isAllGetScore(scoreList) {
	const reg = /[+-]?[0-9]+(\\.[0-9]{1,4})?/
	return scoreList.every(res => {
		return reg.test(res.getScore)
	})
}

function showBigScore(Vue) {
	Vue.component('bigScore', {
		render(createElement) {
			return createElement('div', { class: 'big-total-score' }, [
				createElement('div', this.score, {
					class: 'score-name',
					props: {
						score: {
							type: Number,
							default: 0
						}
					}
				})
			])
		}
	})
}

export { submitScore, isAllGetScore, showBigScore }
